
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-check",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.004 13.282c-.02-.027-.04-.043-.062-.067l-.213-.322a.925.925 0 00-.357-.234l-1.428-.275a.87.87 0 00-.421.087l-1.926 1.592 7.16 10.782a2.053 2.053 0 003.42 0l15.509-23.28L32.019.342 31.642.09a.87.87 0 00-.423-.087L29.78.288a.915.915 0 00-.359.241l-.239.359c-.009.01-.016.016-.025.03L16.468 19.991l-4.464-6.71zM31.86 29.939h-4.101a1.03 1.03 0 000 2.06h4.101a1.03 1.03 0 000-2.06zm-1.054-11.046c-.009.097-.025.191-.036.285a14.76 14.76 0 01-11.215 12.793c-.082.02-.163.03-.244.03-.016 0-.03-.007-.047-.007l-18.236.007a1.03 1.03 0 010-2.06l8.159-.003c-4.263-2.51-7.14-7.143-7.14-12.448 0-7.963 6.468-14.442 14.416-14.442 2.718 0 5.25.771 7.42 2.085l-1.139 1.713a12.252 12.252 0 00-6.282-1.74c-6.816 0-12.36 5.557-12.36 12.384s5.544 12.383 12.36 12.383c6.328 0 11.552-4.79 12.268-10.939.008-.08.025-.161.032-.241.01-.113.008-.227.016-.341.015-.262.034-.52.034-.781h.007c0-.027.003-.054.003-.08 0-1.381-.238-2.705-.656-3.945l1.381-2.074a14.35 14.35 0 011.329 6.02c0 .302-.025.593-.044.889-.008.175-.01.345-.027.515z"}})])
          )
        }
      }
    